<template>
  <div>
    <el-form inline class="demo-form-inline" :model="form">
      <el-form-item label="交易类型">
         <el-cascader
    v-model="form.transactionType"
    :options="options"
    placeholder="请选择"
    :props="{
      multiple: true,
    }"
  ></el-cascader>
      </el-form-item>
      <el-form-item label="交易日期">
        <el-date-picker
          v-model="form.transactionDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeDate"
          >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
        <el-button @click="onExport">导出</el-button>
      </el-form-item>
    </el-form>
    </el-alert>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="created_at" label="交易时间"></el-table-column>
      <el-table-column prop="income_type_txt" label="资金流向"></el-table-column>
      <el-table-column prop="type_txt" label="交易类型"></el-table-column>
      <el-table-column label="金额（元）">
        <template slot-scope="scope">
          <div :style="{ color: scope.row.income_type === '1' ? 'red' : scope.row.income_type === '2' ? 'green' : 'black' }">
            {{ scope.row.income_type === '1' ? '+' : scope.row.income_type === '2' ? '-' : '' }}{{ scope.row.money }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="tran_net_seq_no" label="交易订单编号"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(pagination.total)"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { postMarketingCashLogList } from "@/openapi/erp/supplyAccount.js";
import apiBaseURL from "@/utils/baseUrl.js";
import dayjs from "dayjs";
export default {
  name: "MerchantMarketingAccountLog",
  data() {
    return {
      options: [
        {
          value: '1',
          label: '收入',
          children: [
          
            {
              value: '2',
              label: '充值',
            },
        
              {
              value: '5',
              label: '结算营销费用',
            },
              {
              value: '6',
              label: '提现失败资金退回',
            },
          ],
        },
        {
          value: '2',
          label: '支出',
          children: [
           
            {
              value: '1',
              label: '提现',
            },
              {
              value: '3',
              label: '消费',
            },
             {
              value: '4',
              label: '冻结营销金额',
            },
          ],
        },
      ],
      form: {
        transactionType: [],
        transactionDate: [],
        canExport: false,
      },
    tableData: [],
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      description: {
        total: "",
        freeze: "",
        balance: "",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    changeDate(val) {
      console.log("changeDate", val);
      this.form.transactionDate = val.map((date, index) => {
        let formattedDate = dayjs(date).format('YYYY-MM-DD');
        return index === 0 ? `${formattedDate} 00:00:00` : `${formattedDate} 23:59:59`;
      });
    },
    fetchData() {
      let params = {
        supply_id: this.$route.params.id,
        type: this.form.transactionType.map(arr => arr[1]) || [],
        created_at: this.form.transactionDate || [],
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
      };
      postMarketingCashLogList(params).then((res) => {
        this.tableData = res.list;
        this.pagination.total = res.total;
      });
    },
    exportData() {
      console.log("exportData");

      let params = {
        supply_id: this.$route.params.id,
        type: this.form.transactionType.map(arr => arr[1]) || [],
        created_at: this.form.transactionDate,
        is_excel: 1,
      };
      postMarketingCashLogList(params).then((res) => {
        console.log("🚀 : postMarketingAccountList : res:", res);
        window.open(apiBaseURL + res.file);
      });
    },
    handleSizeChange(val) {
      console.log(`Each page ${val} lines`);
      this.pagination.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      console.log(`Currently on page ${val}`);
      this.pagination.currentPage = val;
      this.fetchData();
    },
    onSearch() {
      console.log("onSearch");
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    onReset() {
      console.log("onReset");
      this.form.transactionDate = [];
      this.form.transactionType = [];
    },
    onExport() {
      console.log("onExport!");
      this.exportData();
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 20px; /* Adjust as needed */
}
</style>



// WEBPACK FOOTER //
// src/pages/MerchantMarketingAccount/MerchantMarketingAccountLog.vue